export const education = [
  {
    id: 1,
    title: "Northeastern University",
    location: "Boston, Massachusetts, USA",
    date: "September'21 - May'24",
    degree: "Master of Science in Information Systems",
    courses:
      " • Application Engineering & Development\n" +
      " • Web Design and UI Development \n" +
      " • Program Structures & Algorithms \n" +
      " • Design Patterns \n" +
      " • Network Structures and Cloud Computing",
  },
  {
    id: 2,
    title: "Mumbai University",
    location: "Mumbai, Maharashtra, India",
    date: "August'16 - November'20",
    degree: "Bachelor's in Computer Engineering",
    courses:
      " • Operating Systems \n" +
      " • Database Management & Database Design \n" +
      " • Computer Networks",
  },
];
